// extracted by mini-css-extract-plugin
module.exports = {"eventHeader":"EventHeader_eventHeader__RzzWD","location":"EventHeader_location__VH9W9","date":"EventHeader_date__10Ekk","divider":"EventHeader_divider__2aQpX"};